import { Component, HostListener, ViewChild, inject } from '@angular/core';
import { SiaParamsAndPatternsService, SiaTranslatePipe } from '@sia/shared';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-filters',
  templateUrl: './sia-grid-config-filters.component.html',
  styleUrls: ['./sia-grid-config-filters.component.scss'],
  providers: [
    {
      provide: SiaGridConfigTab,
      useExisting: SiaGridConfigFiltersComponent,
    },
  ],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigFiltersComponent extends SiaGridConfigTab {
  private paramsAndPatternService = inject(SiaParamsAndPatternsService);

  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;

  gridWidgets: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'bar-start-date', name: 'Bar Start Date' },
    { id: 'bar-end-date', name: 'Bar End Date' },
  ];
  gridMatchTypes: any[] = [
    { id: 'mandatory', name: 'Obbligatorio' },
    { id: 'optional', name: 'Opzionale' },
  ];

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridConfigFilters');
    this.tempCols = [];
    this.gridMatchTypes = [];
    this.gridWidgets = [];
    super.ngOnDestroy();
  }
  ngOnInit(): void {
    this.gridConfFiltersTypes = this.paramsAndPatternService.operators;
  }
}
